<template>
  <div v-if="formModel !== null" class="full-width full-height dynamic-form q-pa-md">
    <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs medium-height">
      <jt-dynamic-form v-if="formModel" ref="jtDynamicForm" :inputs="formModel.inputs"
        :interface="formModel.nmInterface" :relacionamentos="formModel.relacionamentos" :model="contractItem" no-scroll
        form-class="jtDFModthis.$gettalReasonJustificationWaste" />
    </div>
    <div v-if="isValueRange()" class="value-range-area ">
      <span class="value-range-area-title">{{ $gettext("VALUE_RANGES") }}</span>
      <ValueRangeFormTable :key="keyTable" :keyTable="keyTable" :rangeToInsert="rangeToInsert" :valueRange="valueRange"
        @addRange="addRange($event)" @removeRange="removeRange($event)"></ValueRangeFormTable>
    </div>
    <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
      <div v-for="(button, i) in formModel.buttons" :key="i" class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon v-if="button.icon" :name="button.icon" size="18px" class="position-icon-filter" />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtTextInput, JtSelect } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { modal } = JtCrud
import 'leaflet/dist/leaflet.css'
import ValueRangeFormTable from './ValueRangeFormTable.vue'
import { buildContractItemUniquenessCombination } from './utilsFunction'
import { serviceTypeStatus } from 'src/shared/inf-tabela-descricao/ServiceType.enum'
@Component({
  components: {
    JtTextInput,
    JtSelect,
    ValueRangeFormTable
  },
  mixins: [modal],
  name: 'ContractItemFormPage',
  props: {
    forms: {},
    title: String,
    updateItem: {},
    residueCarrierDestinationAlreadyUsed: [],
    serviceType: {}
  }
})
class ContractItemFormPage extends Vue {
  formModel = {};
  form = [];
  contractItem = {};
  valueRange = [];
  rangeToInsert = { quantity: null, value: null };
  keyTable = 0;
  nextItemId = 0;

  @Watch('contractItem', { deep: true })
  onFormModelChange (newState) {
    if (!this.isValueRange() && this.contractItem?.contractItemBilling) {
      this.contractItem.contractItemBilling[0].value = newState.unitPrice
    }
  }

  isValueRange () {
    const serviceTypeEnum = serviceTypeStatus()
    return [serviceTypeEnum.RCC.key, serviceTypeEnum.FREIGHT.key, serviceTypeEnum.FREIGHT_APPORTIONMENT.key].includes(this.updateItem.serviceType)
  }

  created () {
    this.generateForm()
  }

  mounted () {
    if (this.IsEditingService()) {
      this.contractItem = { ...this.updateItem }
    }
  }

  IsEditingService () {
    return !!(this.updateItem) && Object.keys(this.updateItem).length > 0
  }

  async generateForm () {
    this.valueRange = []
    this.form = await repository.resolve('contractItem.registrarNovo', this.params)
    this.formModel = this.form[0]

    const isValorizationSale = this.contractItem.serviceType === 20040003
    if (isValorizationSale) {
      const invertedWeighingInput = this.formModel.inputs.find(input => input.name === 'invertedWeighing')
      invertedWeighingInput && (invertedWeighingInput.readonly = true, this.formModel.dadosForm.invertedWeighing = true)
    }

    this.contractItem = { ...this.formModel.dadosForm, ...this.contractItem }

    if (this.contractItem.contractItemBilling && this.contractItem.contractItemBilling.length > 0) {
      this.valueRange = this.contractItem.contractItemBilling.map(item => ({
        ...item,
        id: this.nextItemId++
      }))
    } else {
      this.valueRange = []
    }
  }

  get elInputs () {
    return this.formModel.inputs
  }

  get inputs () {
    return this.form[0].inputs
  }

  async actionButton (button, params, page) {
    if (!this.$refs.jtDynamicForm.isValidForm()) {
      return
    }
    this.getTextFromSelect(this.contractItem.residueType, 'residueType')
    this.getTextFromSelect(this.contractItem.landfill, 'landfill')
    this.getTextFromSelect(this.contractItem.unitMeasureType, 'unitMeasureType')
    this.getTextFromSelect(this.contractItem.product, 'product')
    this.getTextFromSelect(this.contractItem.readjustmentIndex, 'readjustmentIndex')
    this.contractItem.contractItemBilling = this.valueRange.length === 0 ? null : this.valueRange
    this.checkCombinationAlreadyUsed()
    this.$emit('confirm', this.contractItem)
    this.updateItem = {}
  }

  checkCombinationAlreadyUsed () {
    const combination = buildContractItemUniquenessCombination(this.contractItem)
    const combinationCheck = this.residueCarrierDestinationAlreadyUsed.some(item =>
      item.product == combination.product &&
      item.carrier == combination.carrier &&
      item.destination == combination.destination &&
      item.serviceType == combination.serviceType
    )

    if (combinationCheck) {
      if ([20040007, 20040015].includes(combination.serviceType)) {
        messageBox.warn(this.$gettext('COMBINATION_RESIDUE_GENERATOR_DESTINATION_ALREADY_USED'))
      } else {
        messageBox.warn(this.$gettext('PRODUCT_ALREADY_USED_WITH_THIS_SERVICE_TYPE'))
      }
      throw new Error('Destination already in use')
    }
  }

  prepareInputs (inputs) {
    return inputs
  }

  getTextFromSelect (itemValue, inputName) {
    if (this.formModel.relacionamentos[inputName] != null) {
      const textEvent = this.formModel.relacionamentos[inputName].find(type => type.value == itemValue).label
      this.contractItem[inputName + 'Text'] = textEvent
    }
  }

  validateValue (quantity, value) {
    if (!quantity) {
      messageBox.error(this.$gettext('QUANTITY_NOT_NULL'))
      return false
    }

    if (!value) {
      messageBox.error(this.$gettext('VALUE_NOT_NULL'))
      return false
    }

    if (quantity < 0) {
      messageBox.error(this.$gettext('NOT_NEGATIVE_QUANTITY'))
      return false
    }

    if (value < 0) {
      messageBox.error(this.$gettext('NOT_NEGATIVE_VALUE'))
      return false
    }

    if (this.valueRange.some(valueRante => valueRante.value === value)) {
      messageBox.error(this.$gettext('VALUE_ALREADY_ON_TABLE'))
      return false
    }

    if (this.valueRange.some(valueRante => valueRante.quantity === quantity)) {
      messageBox.error(this.$gettext('QUANTITY_ALREADY_ON_TABLE'))
      return false
    }

    return true
  }

  cleanValue () {
    if (this.rangeToInsert.value != null) {
      this.rangeToInsert.value = this.cleanDouble(this.rangeToInsert.value)
    }

    if (this.rangeToInsert.quantity != null) {
      this.rangeToInsert.quantity = this.cleanDouble(this.rangeToInsert.quantity)
    }
  }

  cleanDouble (value) {
    value = value.replace(/\D/g, '')
    value = value.replace(/^0+/, '')

    const tamanhoTexto = value.length

    if (tamanhoTexto > 5) {
      const textoInteiro = value.slice(0, -2)
      const textoDecimal = value.slice(-2)
      value = textoInteiro + '.' + textoDecimal
    } else {
      value = value.padStart(3, '0')
      const textoInteiro = value.slice(0, -2)
      const textoDecimal = value.slice(-2)
      value = textoInteiro + '.' + textoDecimal
    }

    return value
  }

  removeRange (idToRemove) {
    const index = this.valueRange.findIndex(item => item.id === idToRemove)
    if (index > -1) {
      this.valueRange.splice(index, 1)
    }
  }

  addRange () {
    this.cleanValue()
    if (this.validateValue(this.rangeToInsert.quantity, this.rangeToInsert.value)) {
      this.valueRange.push({
        id: this.nextItemId++,
        quantity: +this.rangeToInsert.quantity,
        value: this.rangeToInsert.value.replace('.', ','),
        contractItemBillingType: this.rangeToInsert.contractItemBillingType
      })

      this.valueRange = [...this.valueRange].sort((a, b) => parseFloat(a.quantity) - parseFloat(b.quantity))

      this.rangeToInsert.quantity = null
      this.rangeToInsert.value = null
      this.rangeToInsert.contractItemBillingType = null
    }
    this.keyTable++
  }
}
export default ContractItemFormPage
</script>
<style lang="stylus" scoped>
.tabela {
  width: 100%;
  border-collapse: collapse;
  margin: 20px auto;
}

.tabela th, .tabela td {
  padding: 12px;
  text-align: left;
}

.tabela th {
  background-color: #F2F4F5;
  border-bottom: 2px solid #dddddd;
}

.tabela tr:hover {
  background-color: #f0f0f0;
}

.table-row-divider {
  border-bottom: 1px solid #ddd;

}
.custom-cursor {
  cursor: pointer;
}
.medium-height {
  height: 350px;
}
.value-range-area {
  margin-top: 3rem;
  position: relative;
  z-index: 99999
}
.value-range-area-title {
  font-size: 14pt;
  font-weight: bold;
}
.value-range-input {
  border-radius: 5px;
  border: 1px solid lightgray;
  width: 80%;
  height: 40px;
}
</style>
